// extracted by mini-css-extract-plugin
module.exports = {"priority-description":"groupModal__priority-description"};